module.exports = __webpack_public_path__ + "img/icon-checkmark.5b8b8186.svg";